import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

const TextInputTag = ({
  label,
  length,
  name,
  defaultValue,
  multiple,
  required,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = () => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full h-full" : "hidden"}
    >
      <div className="w-full h-full">
        <label htmlFor={name} className="label capitalize">
          <span className="text-md font-semibold text-darkPrimary dark:text-darkWhite">
            {multiple && length ? label + " " + length : label}
          </span>
          {required && <span className="text-red-500 text-lg">*</span>}
        </label>
        <textarea
          row={4}
          name={visibility ? name : ""}
          defaultValue={defaultValue}
          type="Text"
          className="textarea mt-2 mb-0 textarea-bordered h-[8rem] w-full border border-gray-300 rounded-md px-3 py-2.5 outline-none dark:border-gray-600 bg-transparent hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150"
          required={required}
          id={name}
        />
      </div>
      {multiple && (
        <div>
          <button
            type="button"
            onClick={handleDelete}
            className="btn btn-sm btn-circle"
          >
            <AiOutlineMinus />
          </button>
        </div>
      )}
    </div>
  );
};

export default TextInputTag;
